<template>
    <div @click="$emit('click', $event)" v-if="icon" class="icon-mask" :style="iconMaskStyle" :alt="alt"></div>
 </template>
 
 <script>
 export default {
   name: 'SVGIcon',
   props: {
     icon: {
       type: String
     },
     filePath: {
       type: String,
       default: '/static/img'
     },
     folder: {
       type: String,
       default: null
     },
     alt: {
       type: String,
       default: ''
     }
   },
   computed: {
     iconMaskStyle () {
       return {
         WebkitMaskImage: this.folder ? `url(${this.filePath}/${this.folder}/${this.icon})` : `url(${this.filePath}/${this.icon})`,
         maskImage: this.folder ? `url(${this.filePath}/${this.folder}/${this.icon})` : `url(${this.filePath}/${this.icon})`
       }
     }
   }
 }
 </script>
 
 <style lang="scss" scoped>
   .icon-mask {
     width: 24px;
     height: 24px;
     background-color: currentColor;
     mask-repeat: no-repeat;
     -webkit-mask-repeat: no-repeat;
     mask-position: center;
     -webkit-mask-position: center;
     mask-size: contain;
     -webkit-mask-size: contain;
     transition: background-color 0.3s ease-in-out;
   }
 </style>
 


// WEBPACK FOOTER //
// src/components/materials/SVGIcon.vue